module.exports = __webpack_public_path__ + "img/logoIcon.68b7d576.png";